"use client";

import React from "react";
// import { Link } from "react-router-dom";
import { useEffect, useState, useRef } from "react";
// import { useLocation } from "react-router";
import "./Header.css";
import { usePathname } from "next/navigation";
import Link from "next/link";
import { useDispatch, useSelector } from "react-redux";
import {
  setInquiryPopup,
  setInquiryPopupObj,
  setPropertyList,
} from "@/store/slices/inquirySlice";
import BottomStrip from "../BottomStrip";
import HeaderContactDropdown from "./HeaderContactDropdown";
import Image from "next/image";

export default function Header({
  //   inquiryPopup,
  //   setInquiryPopup,
  adminDetail,
  // propertylist,
  categoryList,

}) {
  const pathName = usePathname();
  const isHomePage = pathName === "/" || pathName === "/about-us";
  
  const inquiryPopup = useSelector((state) => state.inquiry.inquiryPopup);
  const inquiryPopupObj = useSelector((state) => state.inquiry.inquiryPopupObj);
  const propertylist = useSelector((state) => state.inquiry.propertyList);
  const isProjectPage =
    propertylist?.some((project) => `/${project.slug}` === pathName) || false;
  const [hoveredItem, setHoveredItem] = useState(null);
  const [openContactDropdown, setOpenContactDropdown] = useState(false);

  const [isMounted, setIsMounted] = useState(false);
  const [isMobileScreen, setMobileScreen] = useState(false);
  //   const [categoryList, setCategoryList] = useState(null);
  const [megaMenuCategory, setMegaMenuCategory] = useState("");
  const [megaMenuActive, setMegaMenuToggle] = useState(false);
  const [menuToggle, setMenuToggle] = useState(false);
  const [activeIndex, setActiveIndex] = useState(null);
  const contentRefs = useRef([]);
  const toggleAccordion = (index) => {
    setActiveIndex(index === activeIndex ? null : index);
  };

  const dispatch = useDispatch();

  useEffect(() => {
    if (window.innerWidth <= 767) {
      setMobileScreen(true);
    }

    // if (Array.isArray(propertylist)) {
    //   getCategory();
    // }
    setIsMounted(true);
  }, []);

  useEffect(() => {
    setActiveIndex("");
  }, [pathName]);

  const megaMenuClick = (category) => {
    if (megaMenuCategory == category) {
      setMegaMenuCategory("");
      setMegaMenuToggle(false);
    } else {
      setMegaMenuCategory(category);
      setMegaMenuToggle(true);
    }
  };
  const megaMenuClickClose = () => {
    setMegaMenuCategory("");
    setMegaMenuToggle(false);
  };

  if (!categoryList || categoryList.length === 0) return null;

  const [showNavbar, setShowNavbar] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;

      setMegaMenuToggle(false);
      setMegaMenuCategory("");

      // add this
      setIsScrolled(currentScrollY > 50); // 50px pachi class add thase

      if (currentScrollY > lastScrollY) {
        setShowNavbar(false);
      } else {
        setShowNavbar(true);
      }

      setLastScrollY(currentScrollY);
    };

    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, [lastScrollY]);
  useEffect(() => {
    if (typeof window === "undefined") return;
    const shouldLockScroll = menuToggle;

    document.body.style.overflow = shouldLockScroll ? "hidden" : "";

    if (menuToggle) {
      dispatch(setInquiryPopup(false));
    }

    // console.log(menuToggle);

    return () => {
      document.body.style.overflow = "";
    };
  }, [menuToggle]);

  useEffect(() => {
    const shouldLockScroll = menuToggle || megaMenuActive;

    if (shouldLockScroll) {
      const scrollY = window.scrollY;

      document.body.style.position = "fixed";
      document.body.style.top = `-${scrollY}px`;
      document.body.style.left = "0";
      document.body.style.right = "0";
      document.body.style.width = "100%";
    } else {
      const scrollY = Math.abs(parseInt(document.body.style.top || "0"));

      document.body.style.position = "";
      document.body.style.top = "";
      document.body.style.left = "";
      document.body.style.right = "";
      document.body.style.width = "";

      window.scrollTo(0, scrollY);
    }
  }, [menuToggle, megaMenuActive]);

  useEffect(() => {
    const handleEsc = (event) => {
      if (event.key === "Escape" || event.keyCode === 27) {
        // Close mobile menu
        setMenuToggle(false);

        // Close mega menu
        setMegaMenuToggle(false);
        setMegaMenuCategory("");

        // Close inquiry popup (if open)
        dispatch(setInquiryPopup(false));
      }
    };

    window.addEventListener("keydown", handleEsc);

    return () => {
      window.removeEventListener("keydown", handleEsc);
    };
  }, [dispatch]);

  const [selectedProject, setSelectedProject] = useState(
    propertylist?.[0] || null,
  );
  const [mobileProjectOpen, setMobileProjectOpen] = useState(false);

  const shouldShowScrolled = !menuToggle && isScrolled;
  return (
    <>
      <div
        className={`header-wrapper
    ${showNavbar ? "" : "webmenu_hidden"}
    ${menuToggle ? "header_active" : ""}
    ${shouldShowScrolled ? "header_scrolled" : ""}
    ${isHomePage || isProjectPage ? "header_home" : ""}
  `}
      >
        <div className="main-container-fluid">
          <div className="header-flex">
            <div className="header-logo">
              <Link href="/">
                {adminDetail?.logo && (
                  <img
                    src={"/images/logo-blue.svg"}
                    alt={adminDetail.name || "Logo"}
                    fetchPriority="high"
                  />
                )}
              </Link>
            </div>

            <div className="header-links-ul" style={{ minHeight: "1.5rem" }}>
              <ul className="link-font-size ">
                {/* <li className="visible-tab-mobile">
                <div
                  onClick={(e) => {
                    setMenuToggle(false);
                    setOpenContactDropdown(true);
                  }}
                >
                  <img
                    src="/images/icon/call-white.svg"
                    alt="Call icon"
                  />
                </div>
              </li> */}
                <li>
                  <div
                    className={`menubar ${menuToggle ? "active" : ""}`}
                    onClick={() => {
                      setMenuToggle(!menuToggle);
                      setMobileProjectOpen(false);
                      megaMenuClickClose();
                    }}
                  >
                    <div className="bar bar-top"></div>
                    <div className="bar bar-middle"></div>
                    <div className="bar bar-bottom"></div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className={`nb-mega-menu-wrapper ${menuToggle ? "active" : ""}`}>
          <div className="nb-mega-menu-grid">
            {/* LEFT MENU LINKS */}

            <div>
              <ul className="nb-mega-menu-ul">
                <li>
                  <Link href="/" onClick={() => setMenuToggle(false)}>
                    <p>Home</p>
                  </Link>
                </li>
                <li
                  className="visible-tab-mobile"
                  onClick={() => setMobileProjectOpen(!mobileProjectOpen)}
                >
                  <div>
                    <p>Projects</p>
                    <img
                      src="/images/icon/right-menu-arrow.svg"
                      alt=""
                      style={{ width: "24px" }}
                    />
                  </div>
                </li>
                <li>
                  <Link href="/about-us" onClick={() => setMenuToggle(false)}>
                    <p>About Us</p>
                  </Link>
                </li>

                <li>
                  <Link
                    href="/channelpartner"
                    onClick={() => setMenuToggle(false)}
                  >
                    <p>Channel Partner</p>
                  </Link>
                </li>

                <li>
                  <Link href="/vendor" onClick={() => setMenuToggle(false)}>
                    <p>Vendor</p>
                  </Link>
                </li>

                <li>
                  <Link
                    href="/completed-projects"
                    onClick={() => setMenuToggle(false)}
                  >
                    <p>Completed Projects</p>
                  </Link>
                </li>

                <li>
                  <Link
                    href="/media"
                    onClick={() => setMenuToggle(false)}
                  >
                    <p>Media</p>
                  </Link>
                </li>

                <li>
                  <Link href="/blogs" onClick={() => setMenuToggle(false)}>
                    <p>Articles</p>
                  </Link>
                </li>

                <li>
                  <Link href="/career" onClick={() => setMenuToggle(false)}>
                    <p>Careers</p>
                  </Link>
                </li>

                <li>
                  <Link href="/contact-us" onClick={() => setMenuToggle(false)}>
                    <p>Contact</p>
                  </Link>
                </li>

                {/* Mobile only */}
              </ul>
            </div>

            {/* RIGHT PROJECT SECTION */}

            <div className="nb-mega-menu-projects">
              <div className="inner-flex inner-flex-medium">
                <div className="nb-mega-menu-projects-ul">
                  <h2>Projects</h2>
                </div>

                <div>
                  <ul className="nb-mega-menu-projects-ul">
                    {propertylist
                      ?.filter((item) => item.category === "Residential")
                      ?.slice(0, 6)
                      ?.map((data, index) => (
                        <Link
                          key={index}
                          href={`/${data.slug}`}
                          onMouseEnter={() => {
                            setHoveredItem(`project-${index}`);
                            setSelectedProject(data);
                          }}
                          onClick={() => setMenuToggle(false)}
                          onMouseLeave={() => setHoveredItem(null)}
                          style={{
                            opacity:
                              hoveredItem && hoveredItem !== `project-${index}`
                                ? 0.5
                                : 1,
                            transition: "0.3s",
                          }}
                        >
                          <li>
                            <h2>{data.project_title}</h2>

                            <p>
                              {data.size_price}
                              {data.location && ` • ${data.location}`}
                            </p>
                          </li>
                        </Link>
                      ))}
                  </ul>
                </div>
              </div>

              {/* PROJECT IMAGE */}

              <div className="nb-mega-menu-projects-img">
                <Image
                  src={
                    selectedProject?.banner_data?.image_web_full
                      ? `${selectedProject.banner_data.image_web_full}&w=800`
                      : "/images/detail/nB-Palm.png"
                  }
                  fill
                  alt={selectedProject?.project_title || "project"}
                />
              </div>
            </div>
            <div
              className={`visible-tab-mobile mobile-menu-fixed ${
                mobileProjectOpen ? "active" : ""
              }`}
            >
              <div
                className="inner-flex inner-felx-small"
                style={{ gap: "24px" }}
              >
                <div>
                  <div
                    className="flex-row  nb-mega-menu-projects-mob"
                    onClick={() => setMobileProjectOpen(false)}
                  >
                    <img
                      src="/images/icon/back-menu-arrow.svg"
                      alt=""
                      style={{ width: "26px" }}
                    />
                    <p style={{ fontSize: "24px" }}>Projects</p>
                  </div>
                </div>
                <div className="inner-flex projectList_li ">
                  {propertylist != null &&
                    propertylist.length > 0 &&
                    propertylist.map((data, index2) => {
                      if (data.category == "Residential") {
                        return (
                          <div key={index2}>
                            <Link
                              href={`/${data.slug}`}
                              className="header-hover"
                              onClick={() => {
                                setMenuToggle(false);
                                setMobileProjectOpen(false);
                              }}
                            >
                              <div className="inner-flex inner-flex-smallest nb-mega-menu-projects-ul">
                                <div
                                  className=" w100 relative"
                                  style={{ aspectRatio: "1920 / 1500" }}
                                >
                                  <Image
                                    src={`${data.banner_data.image_web_full}&h=844&w=1080&q=100`}
                                    alt={data.project_title || "project"}
                                    fill
                                    style={{ aspectRatio: "32/25" }}
                                  />
                                </div>

                                <li>
                                  <h2>{data.project_title}</h2>

                                  <p>
                                    {data.size_price} <br />
                                    {data.location && `${data.location}`}
                                  </p>
                                </li>
                              </div>
                            </Link>
                          </div>
                        );
                      }
                    })}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          className={`click-overlay ${
            megaMenuActive || menuToggle || openContactDropdown ? "active" : ""
          } `}
          onClick={() => {
            megaMenuClickClose();
            setMenuToggle(false);
            setOpenContactDropdown(false);
          }}
        ></div>
      </div>
      <a
        href="https://wa.me/917575908908"
        target="_blank"
        rel="noopener noreferrer"
        className={
          isProjectPage ? "up-a-bit" : ""
        }
      >
        <div
          className='whatsapp_connect'
        >
          <div className="whatsapp-icon">
            <img
              src="/images/icon/Whatsapp.png"
              alt="NB Group WhatsApp"
            />
          </div>
        </div>
      </a>
      <BottomStrip
        // isAmenityActive={isAmenityOpen}
        // isProximityActive={isProximityOpen}
        isMobilescreen={isMobileScreen}
        projects_full_list_detail={inquiryPopupObj}
      />
      <HeaderContactDropdown
        isMobilescreen={isMobileScreen}
        openContactDropdown={openContactDropdown}
        setOpenContactDropdown={setOpenContactDropdown}
      />
    </>
  );
}
